export default __webpack_public_path__ + "static/media/5g-just-got-real.3aff5bf6.png";